import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';

import { AgmCoreModule } from '@agm/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IonicStorageModule } from '@ionic/storage';
import { ServiceWorkerModule } from '@angular/service-worker';

import { environment } from '../environments/environment';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { TranslateProvider, HotelProvider } from './providers';

// Modal Pages
import { ImagePageModule } from './pages/modal/image/image.module';
import { LocationPageModule } from './pages/modal/location/location.module';

import { UtilLibraryModule, LibraryConfig, LibraryConfigService } from '@logicaghl/util-library';
import { LibraryUrls } from './interfaces/config';
import { LaunchNavigator } from '@ionic-native/launch-navigator/ngx';
import { AppVersion } from '@ionic-native/app-version/ngx';


export let config: LibraryUrls = {
  frontendUrl: 'http://localhost:4200',
  backendUrl: 'https://tc.ghlink.com',
  apiUrl: 'api/',
  tcServer: 'https://tc.ghlink.com',
  tcApiUrl: 'api/',
  tcContractUrl: 'Contract',
  tcContractFindService: 'FindMicroContracts',
  lqServer: 'https://logiquest.ghlink.com',
  lqApiUrl: 'api/',
  bookingURL: 'https://intranetghl.backhotelengine.com/es/intranet?iframe=True&partner=1982&cp=ExplorersC4sL3aB0lR0d&num_socio='
};

const libraryConfig: LibraryConfig<LibraryUrls> = {
  baseUrls: config
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(environment.config),
    AppRoutingModule,
    HttpClientModule,
    ImagePageModule,
    LocationPageModule,
    IonicStorageModule.forRoot({
      name: '__explorersApp',
      driverOrder: ['indexeddb', 'sqlite', 'websql']
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD9BxeSvt3u--Oj-_GD-qG2nPr1uODrR0Y'
    }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    UtilLibraryModule.forRoot(),
    
    
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    TranslateProvider,
    LaunchNavigator,
    InAppBrowser,
    HotelProvider,
    AppVersion,
    { provide: LibraryConfigService, useValue: libraryConfig }
  ],
  exports:[
    
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
